import { post } from "../network/index.js";
//核销y验券 - 券码查询
const getCodeInfo = (data) => {
  return post("/mercWebi/orderCode/getCodeInfo", data);
};

//核销验券 - 券码核销
const verifyCode = (data) => {
  return post("/mercWebi/orderCode/verifyCode", data);
};
//验券记录 - 验券列表
const getCodeList = (data) => {
  return post("/mercWebi/orderCode/getCodeList", data);
};
//验券记录 - 导出验券列表
const downCodeList = (data) => {
  return post("/mercWebi/orderCode/downloadWebCodeList", data);
};
//待处理任务
const checkTask = (data) => {
  return post("/mercWebi/mercInfo/checkTask", data);
};
const queryStatistic = (data) => {
  return post("/mercWebi/mercInfo/queryStatistic", data);
};
export default {
  verifyCode,
  getCodeInfo,
  getCodeList,
  downCodeList,
  checkTask,
  queryStatistic,
};
